import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing as sp } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { responsiveProp, responsivePropTypes, } from '../utils/responsiveProp';
export var Content = styled(function (_a) {
    var children = _a.children, maxWidth = _a.maxWidth, padding = _a.padding, htmlAttributes = __rest(_a, ["children", "maxWidth", "padding"]);
    return React.createElement("div", __assign({}, htmlAttributes), children);
})(function (_a) {
    var _b = _a.maxWidth, maxWidth = _b === void 0 ? 1920 : _b, _c = _a.padding, padding = _c === void 0 ? 'medium' : _c;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n  margin-left: auto;\n    margin-right: auto;\n    ", "\n  "], ["\n    ", "\n    ", "\n  margin-left: auto;\n    margin-right: auto;\n    ", "\n  "])), fontStack, responsiveProp(padding, undefined, function (val) { return val && "padding: " + sp[val] + ";"; }), maxWidth && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), maxWidth));
});
Content.propTypes = {
    maxWidth: PropTypes.oneOf([1920, 1440, null]),
    padding: responsivePropTypes(PropTypes.oneOf([
        'none',
        'xxx-small',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ])),
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Content.js.map